module.exports = __webpack_public_path__ + "img/dengdai_xq.c2ff9e62.png";